import { createContext, useContext } from 'react';
import type { WatermarkPosition } from '@/lib/watermark/watermarkPosition';

/** The parent project/library's watermark position, provided by the clips
 *  pages so every card preview draws it without prop threading. Read by
 *  ProjectPreview (outside the Player) and forwarded as an input prop. */
export const WatermarkPositionContext = createContext<WatermarkPosition | null>(null);
export const useWatermarkPositionContext = () => useContext(WatermarkPositionContext);
